<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :close-action="() => { $GlobalStore.closeLastModal() }" :title="'친구'" :back-title="'뒤로가기'"></MercenaryHeader>
        <!-- <div style="display: flex; justify-content: center; align-items: center; gap: 4px; position: sticky; top: 0; background-color: #fff; padding: 8px 0; z-index: 5;">
            <div @click="setTopBtn(BTN_TYPE.FRIENDS)" :style="{ color: curType === BTN_TYPE.FRIENDS ? '#fff' : '#808080', backgroundColor: curType === BTN_TYPE.FRIENDS ? '#210f03' : '' }" class="top_btn">친구</div>
            <div @click="setTopBtn(BTN_TYPE.FAMILY)" :style="{ color: curType === BTN_TYPE.FAMILY ? '#fff' : '#808080', backgroundColor: curType === BTN_TYPE.FAMILY ? '#210f03' : '' }" class="top_btn">가족</div>
        </div> -->
        <div style="margin-top: 4px; padding: 0 12px; position: relative;">
            <img style="width: 20px; position: absolute; top: 50%; margin-left: 12px; transform: translateY(-50%);" :src="require('@/assets/img/search_gray_new.png')" alt="">
            <input placeholder="검색" style="width: 100%; border: none; background-color: #f5f5f5; padding: 10px; padding-left: 40px; border-radius: 12px; outline: none;" type="text" v-model="searchWord" @keyup="enter">
        </div>
        <InfinityScroll v-if="curType === BTN_TYPE.FRIENDS" style="flex: 1; overflow-y: scroll; overflow-x: hidden; margin-top: 12px;" :handle-next-page="handleNextPage1" :is-enable-next-page-handle="isEnableNextPageHandle1">
            <div style="overflow-x: hidden;">
                <div v-for="each, i in friendsList" :key="i" @touchstart="touchStart($event, i)" @touchmove="touchMove($event, i)" @touchend="touchEnd($event, i)" :ref="'item_friends' + i" style="display: flex; margin-bottom: 24px; transition: all 0.3s; padding: 0 12px; justify-content: space-between; align-items: center; position: relative;">
                    <div style="display: flex; gap: 8px; align-items: center;">
                        <div @click.stop="$Util.showProfile(each.member_idx)">
                            <ProfileImage style="width: 50px;" :image-path="each.image_path"></ProfileImage>
                        </div>
                        <div>
                            <div style="font-weight: 900; font-size: 14px; line-height: 24px;">{{ each.nic_name }} <span style="font-weight: 700; color: var(--color-main); font-size: 12px;">{{ each.position }}</span></div>
                            <div v-if="each.is_liked == 1" style="display:grid; color:#606060; font-weight:500; font-size:12px;">🧡 응원하는 친구</div>
                            <div v-else style="display:grid; color:#606060; font-weight:500; font-size:12px;">⚽ 익숙한 친구</div>
                            <!-- <div style="font-weight: 700; font-size: 12px; line-height: 18px; color: #808080;">친구 {{ each.friend_cnt | comma }}명</div> -->
                        </div>
                    </div>
                    <div style="display: flex; gap: 12px; position: absolute; right: -104px; padding-right: 12px;">
                        <div style="padding: 8x 20px; width: 78px; line-height: 24px; display: flex; flex-shrink: 0; align-items: center; justify-content: center; font-size: 14px; font-weight: 700; color: var(--color-main); background-color: #f5f5f5; border-radius: 12px;" @click="showPersonalChat(each.member_idx)" @touchstart.stop="() => { }">메시지</div>
                        <div style="padding: 8px 20px; line-height: 24px; display: flex; flex-shrink: 0; align-items: center; justify-content: center; font-size: 14px; font-weight: 700; color: #210f03; background-color: var(--color-main); border-radius: 12px;" @click="deleteFriend(each.member_idx, i)">친구 삭제</div>
                    </div>
                </div>
            </div>
        </InfinityScroll>
        <InfinityScroll v-if="curType === BTN_TYPE.FAMILY" style="flex: 1; overflow-y: scroll; overflow-x: hidden; margin-top: 12px; padding: 0 12px;" :handle-next-page="handleNextPage2" :is-enable-next-page-handle="isEnableNextPageHandle2">
            <div v-for="each, i in familyList" :key="i" style="display: flex; margin-bottom: 24px; transition: all 0.3s; justify-content: space-between; align-items: center; position: relative;">
                <div style="display: flex; gap: 8px; align-items: center;">
                    <div>
                        <ProfileImage style="width: 50px;" :image-path="each.image_path"></ProfileImage>
                    </div>
                    <div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.nic_name }}</div>
                        <div style="font-weight: 700; font-size: 12px; line-height: 18px; color: #808080;">{{ each.phone }}</div>
                    </div>
                </div>
                <!--<div style="display: flex; gap: 12px; position: absolute; right: -103px;">-->
                <!--<div style="padding: 8x 20px; width: 78px; line-height: 24px; display: flex; flex-shrink: 0; align-items: center; justify-content: center; font-size: 14px; font-weight: 700; color: var(&#45;&#45;color-main); background-color: #f5f5f5; border-radius: 12px;" @click="showPersonalChat(each.member_idx)" @touchstart.stop="() => {}">메시지</div>-->
                <!--<div style="padding: 8px 20px; line-height: 24px; display: flex; flex-shrink: 0; align-items: center; justify-content: center; font-size: 14px; font-weight: 700; color: #210f03; background-color: var(&#45;&#45;color-main); border-radius: 12px;" @click="deleteFriend(each.member_idx, i)">친구 삭제</div>-->
                <!--</div>-->
            </div>
        </InfinityScroll>
    </div>
</template>

<script>
import InfinityScroll from "../common/InfinityScroll";
const BTN_TYPE = {
    FRIENDS: '친구',
    FAMILY: '가족'
}

import ProfileImage from "@/components/common/ProfileImage"
import MercenaryHeader from "@/components/common/MercenaryHeader"
import ResponseCode from "../../ResponseCode";
import { JOIN_CHAT_TYPE, MEMBER_TYPE, MY_VIEW_MODE } from "../../Constants";

export default {
    name: 'FriendsList',
    components: {
        InfinityScroll,
        MercenaryHeader, ProfileImage
    },
    props: {
        member_idx: {
            type: [Number, String],
            default: -1
        },
        mode: {
            type: Number,
            default: MY_VIEW_MODE.ME
        },
    },
    data() {
        return {
            curType: BTN_TYPE.FRIENDS,
            BTN_TYPE: BTN_TYPE,
            startX: 0,
            endX: 0,
            curIndex: -1,
            page1: 1,
            page2: 1,
            isEnableNextPageHandle1: true,
            isEnableNextPageHandle2: true,
            friendsList: [],
            familyList: [],
            searchWord: '',
            MY_VIEW_MODE: MY_VIEW_MODE
        }
    },
    created() {
        this.deleteFriend = this.$Once(this.deleteFriend);
        this.getFriendsList()
        console.log(this.mode)
    },
    methods: {
        async showPersonalChat(member_idx) {
            await this.$Axios.showPersonalChat(member_idx, MEMBER_TYPE.USER, JOIN_CHAT_TYPE.SINGLE);
        },
        enter(e) {
            if (e.keyCode === 13) {
                this.refresh();
            }
        },
        refresh() {
            if (this.curType === BTN_TYPE.FRIENDS) {
                this.page1 = 1;
                this.isEnableNextPageHandle1 = true;
                this.friendsList = [];
                this.getFriendsList()
            } else if (this.curType === BTN_TYPE.FAMILY) {
                this.page2 = 1;
                this.isEnableNextPageHandle2 = true;
                this.familyList = [];
                this.getFamilyList()
            }
        },
        async getFriendsList() {
            this.isEnableNextPageHandle1 = false;

            const parameters = {};
            parameters.page = this.page1;
            parameters.searchWord = this.searchWord;
            parameters.member_idx = this.member_idx;

            const res = await this.$Axios.get('/api/member/friend/mine', { params: parameters });
            const member_friends = res.data.member_friends;
            if (member_friends.length > 0) {
                this.isEnableNextPageHandle1 = true;
                this.friendsList = [...this.friendsList, ...member_friends];
            }
        },
        async getFamilyList() {
            this.isEnableNextPageHandle2 = false;

            const parameters = {};
            parameters.page = this.page2;
            parameters.searchWord = this.searchWord;
            parameters.member_idx = this.member_idx;

            const res = await this.$Axios.get('/api/member/family/mine', { params: parameters });
            const member_family = res.data.member_family;
            if (member_family.length > 0) {
                this.isEnableNextPageHandle2 = true;
                this.familyList = [...this.familyList, ...member_family];
            }
        },
        setTopBtn(type) {
            this.curType = type;
            this.searchWord = '';
            this.refresh();
        },
        touchStart(e, i) {
            if (this.mode === MY_VIEW_MODE.ME) {
                this.startX = e.touches[0].clientX
                this.curIndex = i
            }
        },
        touchMove(e) {
            if (this.mode === MY_VIEW_MODE.ME) {
                this.endX = e.touches[0].clientX
            }
        },
        touchEnd() {
            if (this.mode === MY_VIEW_MODE.ME) {
                const diff = this.endX - this.startX

                if (diff < -50) {
                    this.$refs['item_friends' + this.curIndex][0].style.transform = 'translateX(-103px)'
                } else {
                    this.$refs['item_friends' + this.curIndex][0].style.transform = 'translateX(0)'
                }
            }
        },
        handleNextPage1() {
            this.page1++;
            this.getFriendsList();
        },
        handleNextPage2() {
            this.page2++;
            this.getFamilyList();
        },
        async deleteFriend(member_idx, index) {
            if (!confirm('정말로 삭제하시겠습니까?')) {
                return;
            }

            const parameters = {};
            parameters.target_idx = member_idx;

            const res = await this.$Axios.post('/api/member/friend/delete', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$delete(this.friendsList, index);
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }

        }
    }
}
</script>

<style scoped>
.top_btn {
    width: 53px;
    height: 40px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
}
</style>